<template>
  <div>
    <v-dialog
      :value="true"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="slide-y-reverse-transition"
      max-width="900"
      scrollable
      persistent
    >
      <ArticleForm
        :article="editedArticle"
        :errors="articleValidationErrors"
        :images-errors="imagesErrors"
        :disabled="savingArticle"
        @clear:errors="clearArticleValidationErrors"
        @cancel="$router.push({ name: 'articles', query: articleFilterParams })"
        @save="onSave"
        @preview="onPreview"
        @upload:image="onImageUpload"
        @delete:image="onImageDelete"
        @reorder:images="reorderArticleImages"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapErrorsToInputs } from '@/util/forms.js';
import ArticleForm from '../../components/ArticleForm';
import store from '../../store';

export default {
  name: 'EditArticle',

  components: { ArticleForm },

  data() {
    return {
      imagesErrors: [],
    };
  },

  computed: {
    ...mapState('articles', [
      'editedArticle',
      'articleValidationErrors',
      'savingArticle',
      'articleFilterParams',
    ]),
  },

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('articles/editArticle', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'articles' });
      });
  },

  methods: {
    ...mapActions('articles', [
      'updateArticle',
      'clearArticleValidationErrors',
      'uploadArticleImage',
      'deleteArticleImage',
      'reorderArticleImages',
    ]),

    onSave(article) {
      this.updateArticle(article).then(() => {
        this.$router.push({ name: 'articles', query: this.articleFilterParams });
      });
    },

    onPreview(article) {
      this.updateArticle(article).then(() => {
        if (article.type === 'news') {
          window.open(this.$previewBackendUrl(`straipsniai/naujienos/${article.id}?`));
        } else {
          window.open(this.$previewBackendUrl(`straipsniai/renginiai/${article.id}?`));
        }
      });
    },

    onImageUpload(image, type, modelType, modelId) {
      this.imagesErrors = [];
      this.uploadArticleImage({
        image,
        type,
        modelType,
        modelId,
      }).catch((err) => {
        const errors = mapErrorsToInputs(err);
        Object.values(errors).forEach((errorArray) => {
          for (let i = 0; i < errorArray.length; i++) {
            this.imagesErrors.push(errorArray[i]);
          }
        });
        throw err;
      });
    },

    onImageDelete(image) {
      this.deleteArticleImage(image);
    },
  },
};
</script>

<style scoped></style>
